exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".back-to-top{width:45px;height:45px;border-radius:50%;position:fixed;overflow:hidden;background:#fff;box-shadow:0 0 10px rgba(0,0,0,.2);right:18px;bottom:100px;display:flex;align-items:center;justify-content:center}.back-to-top img{width:30px;height:30px}.back-to-top a{text-decoration:none;color:#89128c}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js?outputStyle=expanded!./src/styles/BackToTop.scss
// module id = 911
// module chunks = 0